<template>
  <div class="intro-block" :class="`intro-block--${blockData.color}`">
    <div class="intro-block__intro">
      <div
        class="intro-block__intro-content"
        :class="{'intro-block__intro-content--right': blockData.textRight}"
        :style="`width: ${blockData.textWidth || 50}%;`">
        <div v-if="blockData.labelText">
          <oie-base-label
            class="intro-block__intro-content__tag"
            :is-type="blockData.labelType"
            :text="blockData.labelText"></oie-base-label>
        </div>
        <component :is="blockData.headerTag || 'h1'" v-if="blockData.heading" :class="`.${blockData.headerSize || 'h1'}`">
          {{ blockData.heading }}
        </component>
        <oie-text-formatter v-if="blockData.intro" :content="blockData.intro" class="intro-block__intro-text"></oie-text-formatter>
        <div v-if="blockData.body || blockData.buttonLink" class="intro-block__intro-content-buttons">
          <oie-base-action
            v-if="blockData.body"
            theme="outlined"
            :class="{'intro-block__button--white': blockData.color === 'dark-blue'}"
            @click="() => expanded = !expanded">
            <template v-slot:iconAppend>
              <oie-base-icon :icon="expanded ? 'chevron-up' : 'chevron-down'" size="s"></oie-base-icon>
            </template>

            {{ expanded ? tStatic('minimizeLinkText') : tStatic('readMoreLinkText') }}
          </oie-base-action>
          <oie-base-action
            v-if="blockData.buttonLink"
            theme="outlined"
            :class="{'intro-block__button--white': blockData.color === 'dark-blue'}"
            :url="blockData.buttonLink">
            <template v-slot:iconAppend>
              <oie-base-icon icon="arrow-right" size="s"></oie-base-icon>
            </template>
            {{ blockData.buttonText }}
          </oie-base-action>
        </div>
      </div>
      <div class="intro-block__intro-media" :style="`width: ${100 - blockData.textWidth || 50}%;`">
        <img
          v-if="blockData.imageLink"
          :src="blockData.imageLink"
          :alt="blockData.imageAltText">
      </div>
    </div>

    <!-- v-show, not v-if: the text is in the page from the start and only hidden until "Läs mer" is
         clicked. With v-if it did not exist until the click, and a crawler never clicks, so Google
         indexed the heading and intro but never the body (OC-3285). -->
    <div v-if="blockData.body" v-show="expanded" class="intro-block__body">
      <oie-text-formatter :content="blockData.body"></oie-text-formatter>
      <oie-base-action
        v-if="blockData.body"
        theme="outlined"
        :class="{'intro-block__button--white': blockData.color === 'dark-blue'}"
        @click="() => expanded = false">
        <template v-slot:iconAppend>
          <oie-base-icon icon="chevron-up" size="s"></oie-base-icon>
        </template>
        {{ tStatic('minimizeLinkText') }}
      </oie-base-action>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  props: {
    blockData: { type: Object, required: true, default: null }
  },
  setup() {
    const expanded = ref(false)
    return {
      expanded
    }
  }
})
</script>

<style lang="scss">
.intro-block {
  margin-bottom: measure(full);
}
.intro-block__intro {
  display: flex;
  height: 25rem;
}
.intro-block--white {
  background-color: white;
}
.intro-block--gray {
  background-color: color(gray-5);
}
.intro-block--dark-blue {
  background-color: color(brand-blue-2);
  color: white;
}
.intro-block__button--white {
  border-color: white;
  color: white;
}
.intro-block__intro-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: measure(half);
  >* {
    margin-top: measure(full);
    &:first-child {
      margin-top: auto;
    }
  }
}
.intro-block__intro-text {
  overflow: hidden;
}
.intro-block__intro-content-buttons {
  display: flex;
  flex-wrap: wrap-reverse;
  gap: measure(half);
}
.intro-block__intro-media {
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.intro-block__body {
  padding: measure(half);
  >.base-action {
    margin-top: measure(full);
  }
}
@media (min-width: 769px) {
  .intro-block__intro-content--right {
    order: 2;
  }
}
@media (max-width: 768px) {
  .intro-block__intro {
    flex-direction: column;
    height: unset;
  }
  .intro-block__intro-content {
    order: 2;
    width: 100% !important;
  }
  .intro-block__intro-media {
    width: 100% !important;
  }
  .intro-block--transparent {
  .intro-block__body,
  .intro-block__intro-content {
    padding-inline: unset;
  }
}
}
</style>
